export default __webpack_public_path__ + "static/media/img_filterNoData_google.4631a1ce.svg";